module.exports = __webpack_public_path__ + "img/logo_tct.1120846a.png";